import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-svgo_fieldsGroup",
  "use": "icon-svgo_fieldsGroup-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-svgo_fieldsGroup\"><g stroke=\"#1989FA\" stroke-linejoin=\"round\"><path d=\"M8 2l6 3-6 3-6-3z\" /><path stroke-linecap=\"round\" d=\"M14 8l-6 3-6-3M14 11l-6 3-6-3\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol